module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/182-niue-9537822457a639d8c03d3d017144940e.svg";